module.exports = __webpack_public_path__ + "img/newhouse_thumb.3bcc419e.jpg";